import { createAsyncActionType } from './index';

export const GET_LEAD_LIST = createAsyncActionType('lead', 'GET_LEAD_LIST');
export const CREATE_LEAD_B2B = createAsyncActionType('lead', 'CREATE_LEAD_B2B');

export const CHECK_LEAD_CREATION = createAsyncActionType(
  'lead',
  'CHECK_LEAD_CREATION'
);

export const CREATE_LEAD_B2C = createAsyncActionType('lead', 'CREATE_LEAD_B2C');

export const UPDATE_LEAD_STATUS = createAsyncActionType(
  'lead',
  'UPDATE_LEAD_STATUS'
);

export const DOWNLOAD_LEAD_LIST = createAsyncActionType(
  'lead',
  'DOWNLOAD_LEAD_LIST'
);

export const DOWNLOAD_LEAD_SAMPLE = createAsyncActionType(
  'lead',
  'DOWNLOAD_LEAD_SAMPLE'
);

export const BULK_LEAD_CREATION = createAsyncActionType(
  'lead',
  'BULK_LEAD_CREATION'
);

export const DOWNLOAD_CSV = createAsyncActionType('lead', 'DOWNLOAD_CSV');

export const FETCH_CSV_HISTORY = createAsyncActionType(
  'lead',
  'FETCH_CSV_HISTORY'
);

export const GET_ROW_ID_STATUS = createAsyncActionType(
  'lead',
  'GET_ROW_ID_STATUS'
);

export const STOP_FILE_HISTORY_POLLING = createAsyncActionType(
  'lead',
  'STOP_FILE_HISTORY_POLLING'
);
